// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"319":"fe36e7c9","740":"7c6bc997"}[chunkId] + ".chunk.css";
};